import { render, staticRenderFns } from "./mainLayout.vue?vue&type=template&id=09674c0c&scoped=true&"
import script from "./mainLayout.vue?vue&type=script&lang=js&"
export * from "./mainLayout.vue?vue&type=script&lang=js&"
import style0 from "./mainLayout.vue?vue&type=style&index=0&id=09674c0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09674c0c",
  null
  
)

export default component.exports